import React, { useState } from "react";
import classnames from "classnames";

import styles from "./FinancialPolicy.module.css";

interface Props {
  purchaseRestriction: string;
  loan: string;
  updatePurchaseRestriction: (purchaseRestriction: string) => void;
  updateLoan: (loan: string) => void;
}

function FinancialPolicy(props: Props) {
  const { purchaseRestriction, loan, updatePurchaseRestriction, updateLoan } = props;
  const [unlimitedPurchase, setUnlimitedPurchase] = useState("");
  const [loanable, setLoanable] = useState("");
  return (
    <div className={styles.container}>
      <div className={styles.label}>金融政策</div>
      <div className={styles.value}>
        <button
          className={classnames(styles.default, {
            [styles.active]: !purchaseRestriction  && !loan
          })}
          onClick={() => {
            setUnlimitedPurchase("");
            setLoanable("");
            updatePurchaseRestriction("");
            updateLoan("");
          }}
        >
          不限
        </button>
        <div 
          className={styles.wrapper}
          onClick={()=>{
            setUnlimitedPurchase(unlimitedPurchase?"":"1");
            updatePurchaseRestriction(unlimitedPurchase?"":"1");
          }}
        >
          <div className={[styles.select, unlimitedPurchase && styles.selected].join(" ")}></div>
          <div className={styles.selecttxt}>不限购</div>
        </div>
        <div 
          className={styles.wrapper}
          onClick={()=>{
            setLoanable(loanable?"":"1");
            updateLoan(loanable?"":"1");
          }}
        >
          <div className={[styles.select, loanable && styles.selected].join(" ")}></div>
          <div className={styles.selecttxt}>可贷款</div>
        </div>
      </div>
    </div>
  );
}

export default FinancialPolicy;
